export class RouteSummaryAction {
    private readonly action: () => Promise<void>;
    private readonly id: string;
    private enabled: boolean = true;

    constructor(id: string, action: () => Promise<void>) {
        this.id = id;
        this.action = action;
    }

    public getId(): string {
        return this.id;
    }

    public execute(onFinish: () => void): void {
        if (!this.enabled) {
            console.warn(`Action ${this.id} is disabled`);
            return;
        }
        this.action().then(() => {
            if (typeof onFinish === 'function') {
                onFinish();
            }
        });
        // if action is async run it in a promise
        // if (this.action.constructor.name === 'AsyncFunction') {
        //     (this.action as () => Promise<void>)().then(() => {
        //         if (typeof onFinish === 'function') {
        //             onFinish();
        //         }
        //     });
        //     return;
        // } else {
        //     this.action();
        //     if (typeof onFinish === 'function') {
        //         onFinish();
        //     }
        // }
    }

    public isEnabled(): boolean {
        return this.enabled;
    }

    public setEnabled(enabled: boolean): void {
        this.enabled = enabled;
    }
}
